import { render, staticRenderFns } from "./UserLayer.vue?vue&type=template&id=68b830a4&"
import script from "./UserLayer.vue?vue&type=script&lang=js&"
export * from "./UserLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b830a4')) {
      api.createRecord('68b830a4', component.options)
    } else {
      api.reload('68b830a4', component.options)
    }
    module.hot.accept("./UserLayer.vue?vue&type=template&id=68b830a4&", function () {
      api.rerender('68b830a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/components/layer/UserLayer.vue"
export default component.exports